<div class="container-fluid ">
    <div class="row no-gutters justify-content-center mt-1">

        <h4 class="text-center"> {{Strategy?.PartnerName}}
            <button class="" mat-icon-button color="primary" (click)="navigateToAgency()">
                <mat-icon class="material-symbols-outlined">info</mat-icon>
            </button>
        </h4>
        <!-- <h4 class="text-center"> RCS {{Strategy.Rcs}}</h4> -->
        <h4 class="text-center"> {{Strategy?.Portfolio.SamplingPoint.Name}}</h4>
        <h4 class="text-center"> Devis N°{{Strategy?.Portfolio.QuotationCode}}</h4>
    </div>

    <div class="row no-gutters justify-content-center mb-3 ">

        <div class="col-auto">
            @if (Strategy?.StrategyDocumentList[0]) {
            <button class="h-100" mat-fab extended matTooltip="Stratégie + estimatif" color="primary" (click)="getProposition()">
                Stratégie + estimatif
                <mat-icon class="material-symbols-outlined" iconPositionEnd>description</mat-icon>
            </button>
            }
        </div>
        <div class="col-auto">

            @if (Strategy?.StrategyDocumentList[1]) {
            <button class="h-100" mat-fab extended matTooltip="Rapport final" color="primary" (click)="getFinalRapport()">
                Rapport final
                <mat-icon class="material-symbols-outlined" iconPositionEnd>download</mat-icon>
            </button>
            }
        </div>
        <div class="col-auto">
            <button class="h-100" mat-fab extended matTooltip="Rapports d'analyse" color="primary" (click)="getReportListForStrategy()">
                Rapports d'analyse
                <mat-icon class="material-symbols-outlined" iconPositionEnd>picture_as_pdf</mat-icon>
            </button>
        </div>
        <div class="col-auto">

            <button appPreventDoubleClick mat-fab extended color="primary" (throttledClick)="getResultExport(Strategy)" matTooltip="Tableau des résultats">
                Tableau des résultats
                <mat-icon class="material-symbols-outlined" iconPositionEnd>view_list</mat-icon>
            </button>
        </div>
        <div class="col-auto">

            @if (Strategy.CanDownloadSyntheseChantier) {
            <button class="h-100" mat-fab extended matTooltip="Synthèse et clôture du chantier" color="primary" (click)="openSelectionCategoryForSyntheseChantier()">
                Synthèse et clôture du chantier
                <mat-icon class="material-symbols-outlined" iconPositionEnd>folder_check_2</mat-icon>
            </button>
            }
        </div>

    </div>

    <div class="row no-gutters justify-content-center mb-3">

        <mat-button-toggle-group [(ngModel)]="SelectedList" class="col-12 col-md-6 p-0" hideSingleSelectionIndicator="true">
            <mat-button-toggle class="col" [class.selected]="SelectedList === 1" [value]="1" (click)="changeDisplayMode(1)">
                <div>Mesures à planifier</div>
            </mat-button-toggle>
            <mat-button-toggle class="col" [class.selected]="SelectedList === 2" [value]="2" (click)="changeDisplayMode(2)">
                <div>Mesures planifiées</div>
            </mat-button-toggle>
            <mat-button-toggle class="col" [class.selected]="SelectedList === 3" [value]="3" (click)="changeDisplayMode(3)">
                <div>Mesures réalisées</div>
            </mat-button-toggle>
        </mat-button-toggle-group>

        <mat-form-field class="col">
            <mat-select placeholder="Type de mesure" [(ngModel)]="SelectedUsage" (selectionChange)="getZoneOrProcessAvailable()"
                        [compareWith]="compareWith">
                @for (u of UsageList; track u; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{u}} [{{getUsageCounter(i + 1)}}]</span>
                </mat-option>
                }
                <mat-option [value]="0">
                    <span> Processus [{{getUsageCounter(0)}}] </span>
                </mat-option>
                <mat-option [value]="1337">
                    <span> Complémentaires [{{getUsageCounter(1337)}}] </span>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col">
            <mat-select placeholder="Zone / Processus" [(ngModel)]="SelectedZoneOrProcess" multiple (selectionChange)="getMeasuresAvailable()"
                        [compareWith]="compareWith">
                @if (SelectedUsage !== null) {
                <mat-option [value]="ALL">
                    <span>Tous </span>
                </mat-option>
                }
                @for (cm of AvailableZoneAndProcessList; track cm) {
                <mat-option [value]="cm">
                    <span>{{cm.ParentName}} </span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row my-3">
        <table #table mat-table [dataSource]="getDataSource()" class="mat-elevation-z8">

            <ng-container matColumnDef="measure">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Nom Zone / Process </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.ParentName}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Mesure </th>
                <td mat-cell *matCellDef="let element" class="text-center ">
                    <!-- <div class="fs-5 fw-bold circle my-1" [style.background]="element.Color" [style.color]="element.TextColor" [matTooltip]="element.MeasureReferenceDesignation">
        {{element.ChipName}}
      </div> -->
                    <div>
                        {{element.MeasureReferenceDesignation}}
                    </div>
                    <!-- <div *ngIf="element.MeasureReferenceCode === 'HGEMPAV' || element.MeasureReferenceCode === 'HGEMPAPT' || element.MeasureReferenceCode === 'Annexe B'" class="fw-bold circle my-1" style="font-size: 10px;" [style.background]="getColorByMeasureCode(element)">
      {{element.MeasureReferenceName}}
    </div> -->
                </td>
            </ng-container>

            @if (SelectedList === 2 || SelectedList === 3) {
            <ng-container matColumnDef="battery">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Batterie </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if (element.PumpWithBattery) {
                    <mat-icon class="material-symbols-outlined">done</mat-icon>
                    }
                </td>
            </ng-container>
            }

            @if (SelectedList === 2 || SelectedList === 3) {
            <ng-container matColumnDef="express">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Express </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if (element.Rush) {
                    <mat-icon class="material-symbols-outlined">done</mat-icon>
                    }
                </td>
            </ng-container>
            }

            <!-- <ng-container matColumnDef="samplingId"> DEBUG USEFULL
<th mat-header-cell *matHeaderCellDef class="text-center"> Id </th>
<td mat-cell *matCellDef="let element" class="text-center"> {{element.SamplingId}} </td>
</ng-container> -->

            @if (SelectedList === 2 || SelectedList === 3) {
            <ng-container matColumnDef="samplingDate">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Date </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.SamplingDate | date: 'shortDate'}} </td>
            </ng-container>
            }

            @if ( SelectedList === 3) {
            <ng-container matColumnDef="sa">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Sensibilité Analytique </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if (element?.ELIMSResult?.SA) {
                    <span class="badge bg-primary fs-6">
                        {{element?.ELIMSResult?.SA }}
                    </span>
                    }
                </td>
            </ng-container>
            }

            @if ( SelectedList === 3) {
            <ng-container matColumnDef="nbfiber">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Nombre de fibres </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if (element?.ELIMSResult?.NbFiber) {
                    <span class="badge bg-primary fs-6">
                        {{element?.ELIMSResult?.NbFiber }}
                    </span>
                    }
                </td>
            </ng-container>
            }

            @if (SelectedList === 3) {
            <ng-container matColumnDef="concentration">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Concentration </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    @if (element?.ELIMSResult?.ResultConcentration) {
                    <span class="badge bg-primary fs-6">
                        {{element?.ELIMSResult?.ResultConcentration }}
                    </span>
                    }
                </td>
            </ng-container>
            }

            @if (SelectedList === 2 || SelectedList === 3) {
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                    Actions
                </th>
                <td mat-cell *matCellDef="let element" class="text-end">
                    @if (CanBeReOrder(element)) {
                    <button appPreventDoubleClick mat-raised-button matTooltip="Recommander" color="accent" (throttledClick)="reOrderZone(element)">
                        Recommander cette zone
                    </button>
                    }
                    @if (element.HasAreaMap) {
                    <button appPreventDoubleClick mat-icon-button matTooltip="Plan" color="primary" (throttledClick)="getMapFile(element.SamplingId)">
                        <mat-icon class="material-symbols-outlined">map</mat-icon>
                    </button>
                    }
                    @if (element.ELIMSResult) {
                    <button appPreventDoubleClick mat-icon-button matTooltip="Rapport d'analyse" color="primary"
                            (throttledClick)="getELIMSReport(element.SamplingId)">
                        <mat-icon class="material-symbols-outlined">fact_check</mat-icon>
                    </button>
                    }
                </td>
            </ng-container>
            }

            <!-- <span [ngSwitch]="SelectedList">
<span *ngSwitchCase="1">
  <tr mat-header-row *matHeaderRowDef="toPlanDisplayedColumns; sticky: true"></tr>
  <tr mat-row class="clickable" *matRowDef="let row; columns: toPlanDisplayedColumns;" (click)="navigateToOrder(row)"></tr>
</span>
<span *ngSwitchCase="2">
  <tr mat-header-row *matHeaderRowDef="plannedDisplayedColumns; sticky: true"></tr>
  <tr mat-row class="clickable" *matRowDef="let row; columns: plannedDisplayedColumns;" (click)="navigateToOrder(row)"></tr>
</span>
<span *ngSwitchCase="3">
  <tr mat-header-row *matHeaderRowDef="finishedDisplayedColumns; sticky: true"></tr>
  <tr mat-row class="clickable" *matRowDef="let row; columns: finishedDisplayedColumns;" (click)="navigateToOrder(row)"></tr>
</span>
<span *ngSwitchDefault> -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row class="clickable" *matRowDef="let row; columns: displayedColumns;" (click)="navigateToOrder(row)"></tr>
            <!-- </span> -->
            <!-- </span> -->
        </table>
    </div>

    @if (HasExotic() && SelectedList === 3) {
    <div class="row my-3">
        <table #horsStratTable mat-table [dataSource]="getExoticSource()" class="mat-elevation-z8">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Nom </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.ParentName}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Description </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.ParentDescription}} </td>
            </ng-container>
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Date </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.SamplingDate | date: 'shortDate'}} </td>
            </ng-container>
            <ng-container matColumnDef="result">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Résultat </th>
                <td mat-cell *matCellDef="let element" class="text-center ">
                    <div>
                        {{element.ELIMSResult?.NbFiber}} {{element.ELIMSResult?.SA}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                    Actions
                </th>
                <td mat-cell *matCellDef="let element" class="">
                    @if (element.ELIMSResult) {
                    <button appPreventDoubleClick mat-icon-button matTooltip="Rapport d'analyse" color="primary"
                            (throttledClick)="getELIMSReport(element.SamplingId)">
                        <mat-icon class="material-symbols-outlined">fact_check</mat-icon>
                    </button>
                    }
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="exoticDisplayedColumns; sticky: true"></tr>
            <tr mat-row class="clickable" *matRowDef="let row; columns: exoticDisplayedColumns;" (click)="navigateToOrder(row)"></tr>
        </table>
    </div>
    }
</div>